export default "__VITE_ASSET__Ba_y3WvB__"